exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.left-border-line[data-v-f026eaa4] {\n    padding-left: 20px;\n    border-left: 2px solid #FF0000;\n}\n", ""]);

// exports
